<script lang="ts" setup generic="T">
const props = defineProps<{ items: T[], direction?: 'h' | 'v', width?: number, duration?: number, event?: string }>()

const [index] = defineModel<number>({ required: true })

const list = [...props.items]
list.push(list[0])

const el = ref()

// 容器宽高
const boxSize = useElementSize(el)

const _index = ref(index.value)

const reverse = ref<[number, number]>()

watch(index, (v) => {
  // _index.value = v

  const now = _index.value
  if (Math.abs(now - v) > 1) {
    const delta = v - now > 0 ? 1 : -1
    const next = now + delta;
    [list[v], list[next]] = [list[next], list[v]]
    reverse.value = [v, next]
    _index.value = next
    // console.log(reverse.value, _index.value)
  } else {
    _index.value = v
  }
})

watch(_index, (v) => {
  if (reverse.value) {
    const [v, next] = reverse.value
    setTimeout(() => {
      transition.value = false;
      [list[v], list[next]] = [list[next], list[v]]
      _index.value = v
      setTimeout(() => {
        transition.value = true
      }, 1000 / 30)
    }, duration)
    reverse.value = undefined
  } else if (v >= props.items.length) {
    setTimeout(() => {
      transition.value = false
      _index.value = v % props.items.length
      setTimeout(() => {
        transition.value = true
      }, 1000 / 30)
    }, duration)
  } else {
    index.value = _index.value
  }
  // track
})

const transition = ref(true)

const duration = props.duration ?? 800

// 
const offset = computed(() => {
  if (!boxSize.width.value) return 0
  return (-_index.value * boxSize.width.value) + 'px'
})

// 记录 from，to
const track = ref([_index.value])

</script>

<template>
  <div class=" relative overflow-hidden" ref="el" :style="{ '--swipe-duration': duration + 'ms' }">
    <div class=" flex w-[9999px]" v-cloak :class="[transition && 'transition-all ease-in-out']"
      :style="{ transform: `translateX(${offset})` }" v-if="boxSize.width.value">
      <div v-for="v in list" :style="{ width: boxSize.width.value + 'px' }">
        <slot name="item" v-bind="{ item: v }"></slot>
      </div>
    </div>
    <slot name="outer"></slot>
  </div>
</template>

<style lang="scss" scoped>
.transition-all {
  transition-duration: var(--swipe-duration)
}
</style>
